import _ from 'lodash';
import GenerateRequest from './resources';
import { BaseOrder } from './BaseOrder';
import { checkLicenseExpiry } from './ResourceValidations';

const req = GenerateRequest();
export default {
  async getTemplates(params = {}) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.get('matTemplates', { params });
      return new BaseOrder(data);
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async getDefaultTemplate(params = {}) {
    try {
      await checkLicenseExpiry();
      params.getDefault = true;
      const { data } = await req.get('matTemplates/getDefault', { params });
      if (_.isEmpty(data)) { return data; }
      return new BaseOrder(data);
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async create(card) {
    try {
      await checkLicenseExpiry();
      const { data: template } = await req.post('matTemplates/create', card, {
        params: { projectId: card.project._id },
      });
      return template;
    } catch (e) {
      // TODO: Add an alert here?
      console.log(e);
      throw e;
    }
  },
  async update(card) {
    try {
      await checkLicenseExpiry();
      const { data: template } = await req.post('matTemplates/update', card, {
        params: { projectId: card.project._id },
      });
      return template;
    } catch (e) {
      // TODO: Add an alert here?
      console.log(e);
      throw e;
    }
  },
  async archive(card) {
    try {
      await checkLicenseExpiry();
      const { data: order } = await req.post('matTemplates/archive', card);
      return order;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
};
